import { createSelector } from 'reselect';
import { type AsyncStatus } from '../reducers/requestsState';
import { Experiment } from '../types/Experiment';
import { selectPayPalMethodsEligibility, selectExperiments } from './appState';
import { selectApplePayDto } from './applePay';
import {
  selectRequestStateApCanMakePayments,
  selectRequestStateApHighestVersion,
  selectLoadPayPalScriptState,
  selectLoadApplePayScriptState,
} from './requestsState';
import { selectIsPayPalPmAvailable } from './payPal';

const isFullfilledOrRejected = (s: AsyncStatus): boolean => {
  return s === 'fulfilled' || s === 'rejected';
};

export const selectAreResourcesLoaded = createSelector(
  selectIsPayPalPmAvailable,
  selectLoadPayPalScriptState,
  selectPayPalMethodsEligibility,
  selectApplePayDto,
  selectLoadApplePayScriptState,
  selectRequestStateApCanMakePayments,
  selectRequestStateApHighestVersion,
  selectExperiments,
  (
    isPayPalPmAvailable,
    ppScriptState,
    eligibility,
    apDto,
    apScriptState,
    requestStateCanMakePayment,
    requestStateHighestVersion,
    experiments,
  ) => {
    if (isPayPalPmAvailable) {
      if (ppScriptState === 'rejected') {
        return true; // pass through, use selectPayPalPmAndScriptAvailable to check
      }
      if (
        // eligibility filled in store
        Object.keys(eligibility).length > 0 &&
        isFullfilledOrRejected(ppScriptState)
      ) {
        // revise solution
        return true;
      }
      return false;
    }
    if (apDto) {
      // Wait for Apple Pay SDK to load only if experiment is enabled
      const isApplePayInChromeEnabled = experiments?.[Experiment.EnableApplePayInChrome] === 'true';
      if (isApplePayInChromeEnabled && !isFullfilledOrRejected(apScriptState)) {
        return false;
      }
      // Wait for eligibility checks
      if (!isFullfilledOrRejected(requestStateCanMakePayment) || !isFullfilledOrRejected(requestStateHighestVersion)) {
        return false;
      }
    }
    return true;
  },
);
